import deburr from "lodash/deburr";
import { matchPath } from "react-router-dom";

export const slugifyOrgName = (orgName: string): string =>
  deburr(orgName.toLowerCase()).trim().replace(/\W+/g, "-");

const DASHBOARD_PATH = `/orgs/:orgName/:sections*`;
/** Allows us to use generic 'orgs/-/:section' for all users, and still land them
in a valid url corresponding to one of their orgs. For example, if the user's org
is called abc and we send them to orgs/-/projects, they get forwarded to orgs/abc/projects.
This also works for org typos like returntocrp instead of returntocorp. */
export const replaceOrgInPath = (
  pathname: string,
  newOrgName: string
): string => {
  const match = matchPath<{ sections: string; orgName: string }>(pathname, {
    path: DASHBOARD_PATH,
  });
  if (match === null) return pathname;
  return `/orgs/${slugifyOrgName(newOrgName)}/${match.params.sections || ""}`;
};

/**
 * @param orgName name of org (or name of current namespace)
 * @param ruleId id from the rule text
 * @returns orgName:ruleId
 * slugifies orgName and lowercases snippet name
 */
export const getSnippetAliasName = (orgName: string, ruleId: string) => {
  return `${slugifyOrgName(orgName)}:${ruleId}`.toLowerCase();
};
